import React from 'react';
import classNames from 'classnames';

import _Base from './../_Base';

import {Button} from '@components';
import {Props} from './types';

import './index.scss';

const Delete = (props: Props) => {
  return (
    <_Base
      title={props.title}
      isModal={props.isModal}
      handleCloseModal={props.handleCloseModal}
      size={props.size || 'sm'}
    >
      <div className="a__delete-modal">
        <div className="w__message">{props.message}</div>
        <div
          className={classNames('w__modal-buttons', {
            responsive: props.size === 'responsive',
          })}
        >
          <Button.Normal
            text="キャンセル"
            onClick={() => props.handleCloseModal(!props.isModal)}
            disabled={props.disabled || props.loading}
          />
          <Button.Normal
            text={props.confirmText ? `${props.confirmText}` : '削除する'}
            onClick={props.onClick}
            color="red"
            loading={props.loading}
            disabled={props.disabled || props.loading}
          />
        </div>
      </div>
    </_Base>
  );
};
export default Delete;
